import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil-reponses.component.html',
  styleUrls: ['./accueil-reponses.component.scss']
})
export class AccueilReponsesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
